import React from "react";
import {STATUSES} from "../../../admin/components/helena_pro/shared/statusConfig";

const AppointmentStatusLogo = ({ status, label, showBgColor }) => {

    if (!status || !STATUSES[status]){
        return (<span>{label}</span>);
    }

    return (
        <span className="icon-status-container icon-container">
            <span className={`${status}${showBgColor ? '-bg-color' : '-color'} icon-status-circle`}>
                <i className={STATUSES[status]}/>
            </span>
            {label &&
                <span>{label}</span>}
        </span>
    )
}
export default AppointmentStatusLogo;